<template>
	<div class="category-page">
		<h3 class="font-weight-bold">Categories</h3>
		<div class="d-flex justify-content-center">
			<div class="py-5" v-if="showLoader">
				<div class="loader"></div>
			</div>
			
		</div>

		
		<!-- Tabel untuk display kategori -->
		<table class="table table-bordered" v-if="categories.length !== 0">
			<thead>
				<tr>
					<th class="text-center">No</th>
					<th class="text-center">category</th>
					<!-- <th class="text-center">Subcategory</th>
					<th class="text-center">Topic</th> -->
					<th class="text-center">Action</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(category, i) in categories" :key="i">
					<td class="text-center">{{i+1}}</td>
					<td>{{category.name}}</td>
					<!-- <td>{{category}}</td> -->
					<td class="text-center">
						<button class="btn mr-1" @click="selectCategory(category)">detail</button>
						<button class="btn btn-danger" @click="deleteCategory(category)">delete</button>
					</td>
				</tr>
			</tbody>
		</table>
		<hr>
	</div>
</template>

<script>
// import axios from 'axios'
import App from '@/App'

// const _categories = [
// 	{
// 		name: 'Dummy',
// 		subs: [
// 			{
// 				name: "Sub A",
// 				topics: ["Topic A", "Topic B"]
// 			}
// 		]
// 	},
// ];

export default {
	data() {
		return {
			url: App.data().url,
			categories: [],
			subs: [],
			topic: [],
			showLoader: false
		}
	},
	mounted(){
		// this.categories = App.methods.clone(_categories);
		this.getCategories();
	},
	methods: {
		selectCategory(cat){
			this.$root.$emit('category-selected', cat)
		},
		getCategories(){
			this.showLoader = true;
			App.methods.getData(this.url.categories, (data) => {
				if(data){
					this.categories = data;
					this.categories.map(data1 => {
						data1.subs.map(dataSub => {
							this.subs.push(dataSub)
							dataSub.topics.map(dataSub1 =>{
								this.topic.push(dataSub1)
							})
						})
					})
					this.showLoader = false;

				}
			});
		},
		addSubCategory(category) {
			category.subs.push({
				name:"New Sub-Category",
				topics: ["New Topic"]
			});
		},
		addTopic(container) {
			container.push("New Topic")
		},
		saveCategory(type) {
			if(type == 'edit'){
				console.log('save edited category')
			}else{
				console.log('type is not defined')
			}
		},
		deleteCategory(category){
			App.methods.deleteData(this.url.category + '/' + category.aid, (ok) => {
			});
		},
		deleteSubCategory(subs){
			alert("FUNGSINYA BELUM DI BUAT")
		},
		deleteTopic(topic){
			alert("FUNGSINYA BELUM DIBUAT")
		}
	}
}
</script>

<style scoped>
	.loader {
		border: 12px solid #f3f3f3;
		border-radius: 50%;
		border-top: 12px solid #000000;
		/*border-bottom: 15px solid #007bff;*/
		width: 100px;
		height: 100px;
		-webkit-animation: spin 2s linear infinite; /* Safari */
		animation: spin 2s linear infinite;

	}

	/* Safari */
	@-webkit-keyframes spin {
		0% { -webkit-transform: rotate(0deg); }
		100% { -webkit-transform: rotate(360deg); }
	}

	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
</style>

